import { SimpleVideoInterface } from '../iface';

export class VirtualVideoElement implements SimpleVideoInterface {
    muted: boolean = false;
    volume: number = NaN;
    currentTime: number = NaN;
    duration: number = NaN;
}